const skills = {
    languages: [
        { name: "Python", icon: "fa-brands fa-python", lvl: "75%" },
        { name: "JavaScript", icon: "fa-brands fa-js", lvl: "80%" },
        { name: "HTML", icon: "fa-brands fa-html5", lvl: "80%" },
        { name: "Java", icon: "fa-brands fa-java", lvl: "50%" },
        { name: "CSS", icon: "fa-brands fa-css3", lvl: "[90%]" },
    ],

    technologies: [
        { name: "Github", icon: "fa-brands fa-git-alt", lvl: "75%" },
        { name: "React", icon: "fa-brands fa-react", lvl: "[80%]" },
        { name: "Node", icon: "fa-brands fa-node", lvl: "80%" },
        { name: "Windows", icon: "fa-brands fa-microsoft", lvl: "80%" },
    ],
};

export default skills;
